"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportFeedbackDeal = reportFeedbackDeal;
exports.reportFeedbackReply = reportFeedbackReply;
var _adminOperationReport = require("@/utils/adminOperationReport");
/**
 * 【操作埋点】用户反馈模块上报方法
 * 实施时间：2026-05-25
 * 说明：回复反馈、标记处理状态
 */

/**
 * 回复用户反馈
 */
function reportFeedbackReply(feedbackId, title, content) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '回复用户反馈',
    content: "\u56DE\u590D\u53CD\u9988ID ".concat(feedbackId, "\u300C").concat(title || '', "\u300D\uFF1A").concat(content || ''),
    operation_id: 'pc_feedback_reply_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_feedback_reply_1');
}

/**
 * 处理用户反馈
 */
function reportFeedbackDeal(feedbackId, title, dealStatus, remark) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '处理用户反馈',
    content: "\u5904\u7406\u53CD\u9988ID ".concat(feedbackId, "\u300C").concat(title || '', "\u300D\uFF0C\u72B6\u6001\uFF1A").concat(dealStatus, "\uFF0C\u5907\u6CE8\uFF1A").concat(remark || '无'),
    operation_id: 'pc_feedback_deal_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_feedback_deal_1');
}